import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import {SwipeableDrawer} from "@mui/material";
import ContactPhoneOutlinedIcon from '@mui/icons-material/ContactPhoneOutlined';
import ContactsFragment from "../ContactsFragment";
import {grey} from "@mui/material/colors";

export default function OffCanvasPhoneSidebar() {
    const [sidePhoneBarOpen, setSidePhoneBarOpen] = React.useState(false);

    const toggleDrawer = (newOpen) => () => {
        setSidePhoneBarOpen(newOpen);
    };


    // Allow opening from anywhere
    // Make the sidebar expose a global opener (and listen on both window & document)
    React.useEffect(() => {
        const openHandler = () => {
            // console.log('[OffCanvas] open-contacts heard');
            setSidePhoneBarOpen(true);
        };
        // listen on both targets (some setups attach to document)
        window.addEventListener('open-contacts', openHandler);
        document.addEventListener('open-contacts', openHandler);

        // expose an imperative opener as a fallback
        window.__openContacts = openHandler;

        return () => {
            window.removeEventListener('open-contacts', openHandler);
            document.removeEventListener('open-contacts', openHandler);
            delete window.__openContacts;
        };
    }, []);

    const DrawerList = (
        <Box sx={{width: 300}} role="presentation" onClick={toggleDrawer(true)}>
            <ContactsFragment/>
        </Box>
    )

    return (
        <div>

            <Button variant="contained"
                    style={{color: "black", backgroundColor: grey[50], border: "solid 0.5px #b71c1c"}}
                    onClick={toggleDrawer(true)}
                    startIcon={<ContactPhoneOutlinedIcon color="secondary"/>}>
                Контакты
            </Button>
            <SwipeableDrawer open={sidePhoneBarOpen} onClose={toggleDrawer(false)}>
                {DrawerList}
            </SwipeableDrawer>

        </div>
    );
}